export default class BackendValidationError extends Error {}

export const generateErrorFieldPath = (paths: string[]): string => {
  const isNumber = /^\d+$/;
  const pathsWithoutContextName = paths.slice(1);

  if (pathsWithoutContextName.length === 1) {
    return pathsWithoutContextName[0];
  }

  return pathsWithoutContextName.reduce((prev, curr) => {
    if (isNumber.test(curr)) {
      return `${prev}[${curr}]`;
    }

    return `${prev}.${curr}`;
  });
};
